import React, { useState } from 'react';
import {
  Input, Card, Table, Button, Breadcrumb, Col, Row, Space, Spin, Select
} from 'antd';
import { useTranslation } from 'react-i18next';  

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faMicrochip, faBuilding } from '@fortawesome/free-solid-svg-icons';
import {
  ResponsiveContainer,
} from 'recharts';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { FallOutlined, PlusOutlined, RiseOutlined, SearchOutlined } from '@ant-design/icons';

import Map from '@common/components/map/GoogleMap';
import invertesIcon from '@assets/img/markers/convertidor/icon-inverters.png';
import {
  InfoWindow, Marker,
} from '@react-google-maps/api';

import styles from './DashboardAdmin.module.less';
import useDashboardAdmin from './useDashboardAdmin';

const style = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: 25,
  marginTop: 25,
  cursor: 'pointer',
}; 
 
const { Search } = Input;
const { Option, OptGroup } = Select;

function DashboardAdmin() {

  const { t } = useTranslation();
  const {
    loading,
    loadingBusiness,
    isCreate,
    businessData,

    //AMI IoT 
    setValueFilterDevices,
    setStatusDevices,
    createDevice,
    viewMetrica,
    columnsDevices,
    arrayFilterDevices, 

    //Clients
    setValueFilterClients,
    createClient,
    columnsClients,
    arrayFilterClients
  } = useDashboardAdmin();
  
  const [activeMarker, setActiveMarker] = useState(null);
  const handleActiveMarker = (marker) => { 
    if (marker === activeMarker) { 
      return; 
    }
    setActiveMarker(marker); 
  };

  return (
    <div>
      <div className={styles.fields_wrapper} />
      {
        loadingBusiness ? (
          <Row style={{
            width: '100%', magin: 'auto', display: 'flex', justifyContent: 'center', justifyItems: 'center',
          }}
          >
            <Col style={{ justifyContent: 'center', marginTop: '5%' }}>
              <Spin tip={t('views.device_graphics.loading_data_graphs')} />
            </Col>
          </Row>
        ) : (<>
          <Row gutter={[16, 8]}>
            <Col xs={{span: 24}} sm={{span: 24}} md={{span: 8}} lg={{span: 8}} xl={{span: 8}}
            >
                <div style={{
                  background: '#fff',
                  padding: 25,
                  minHeight: '320px',
                  height: 'fit-content',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center', 
                }}>
                  <div style={{ /* Remove unnecessary `justifyContent` property */ }}>
                    <Row gutter={[16, 8]} style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 10 }}>
                      <Col span={8} className="text-right" style={{ color: '#8c8c8c', fontSize: 24, fontWeight: 'bold' }}>
                      <div className={styles.circle_icon_container}>
                        {businessData?.logo_full_url && businessData?.logo_full_url !== ''
                          ? (
                            <img
                              src={businessData.logo_full_url}
                              alt={businessData.name}
                              className="image-logo-busines-detail"
                            />
                          )
                          : (
                            <FontAwesomeIcon icon={faBuilding} style={{ fontSize: 20, color: '#ffffff' }} />
                          )}
                      </div>
                      </Col>
                      <Col span={16}>
                        <Row style={{ color: '#8c8c8c', fontSize: 24, fontWeight: 'bold' }}>
                          {businessData?.name || ''}
                        </Row>
                        <Row style={{ fontSize: '14px', color: '#8c8c8c' }}>
                          <Breadcrumb className="date_wrapper">
                            <Breadcrumb.Item className="breadcrumb">
                              <Link to="/">{t('menu_items.main.home')}</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item className="breadcrumb">
                              {businessData?.name || ''}
                            </Breadcrumb.Item>
                          </Breadcrumb>
                        </Row>
                      </Col>
                    </Row>
                    <p className="text-center" style={{ color: '#8c8c8c' }}>
                      {businessData?.description || ''}
                    </p>
                    <div className="text-center" style={{ padding: 10, borderRadius: 10, textAlign: 'center' }}>
                      <span style={{ fontSize: 14, fontWeight: 'bold', margin: '0 0.5rem' }}>
                        {t('common.type')} :
                        {' '}
                        {businessData?.type || ''}
                      </span>
                      <span style={{ fontSize: 14, fontWeight: 'bold', margin: '0 0.5rem' }}>
                        {t('common.clients')} :
                        {' '}
                        {businessData?.total_general_clients || 0}
                      </span> 
                      {
                      businessData?.ext_community?.type === 'AmiIoT' && 
                      <>
                        <br></br>
                        <span style={{ fontSize: 14, fontWeight: 'bold', margin: '0 0.5rem' }}>
                          Total dispositivos:
                          {' '}
                          {businessData.total_general}
                        </span>
                        <span style={{ fontSize: 14, fontWeight: 'bold', margin: '0 0.5rem' }}>
                          Conectados:
                          {' '}
                          {businessData.total_conecy}
                        </span>
                      </>
                      }
                      <br></br>
                      <span style={{ fontSize: 14, fontWeight: 'bold', margin: '0 0.5rem' }}>
                        Frt :
                        {' '}
                        {businessData?.ext_community?.frt || ''}
                      </span>
                      <span style={{ fontSize: 14, fontWeight: 'bold', margin: '0 0.5rem' }}>
                        {t('views.create_business_type.form.settlement_cycle')} :
                        {' '}
                        {businessData?.ext_community?.settlement_cycle || ''}
                      </span>  
                      <br></br>
                      <span style={{ fontSize: 14, fontWeight: 'bold', margin: '0 0.5rem' }}>
                        {t('views.create_business_type.form.type_communities')} :
                        {' '}
                        {businessData?.ext_community?.type || ''}
                      </span>  
                      
                    </div>
                  </div>
                </div>

            </Col>
            
            <Col xs={{span: 24}} sm={{span: 24}} md={{span: 8}} lg={{span: 8}} xl={{span: 8}}
            >
              <div style={{  background: '#fff', padding: 25, minHeight: '320px', height: 'fit-content'  }}
              >
                <Row>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <Row className="miga_title">Métricas</Row> 
                  </Col>
                  
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}> 
                      <p style={{ minHeight: '44px', color: '#8c8c8c', marginTop: 5 }}>Enero 01 - Ene 24</p>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={12} xl={12}> 
                    <Select className={styles.select_attribute} value={'mes'}>
                      <Option key={`mes`} value={'mes'}>{'Mes'}</Option> 
                    </Select>
                  </Col>

                  <Row> 
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <div className={styles.cardCustom}>
                          <RiseOutlined  style={{fontSize:18, color:'#ff812e'}} /> <span style={{fontSize:18, fontWeight:'bold'}}>420.000</span> <span className={styles.cardText}>kwh</span><br></br>
                          <span>Energía solar generada</span>
                        </div>
                      </Col>

                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <div className={styles.cardCustom}>
                          <FallOutlined  style={{fontSize:18, color:'#39587d'}} /> <span style={{fontSize:18, fontWeight:'bold'}}>284.430</span> <span className={styles.cardText}>kwh</span><br></br>
                          <span>Energía Consumida</span>
                        </div>
                      </Col>

                      <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                        <div className={styles.cardCustom}>
                          <RiseOutlined  style={{fontSize:18, color:'#ff812e'}} /> <span style={{fontSize:18, fontWeight:'bold'}}>135.570</span> <span className={styles.cardText}>cop</span><br></br>
                          <span>Ganancia generadas</span>
                        </div>
                      </Col> 
                      <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                        <div className={styles.cardCustom} 
                            style={{textAlign:'center',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    cursor:'pointer' 
                            }} onClick={viewMetrica}>
                          <span>Ver mas</span>
                        </div>
                      </Col> 
                  </Row>

                </Row> 
              </div>
            </Col>

            <Col xs={{span: 24}} sm={{span: 24}} md={{span: 8}} lg={{span: 8}} xl={{span: 8}}
            >
              <div style={{  background: '#fff', padding: 25, minHeight: '320px', height: 'fit-content'  }}
              >
                <div className="container_map" style={{height:'260px'}}>
                  <Map>
                    <>
                      {businessData?.latitude && businessData?.longitude  &&
                        <Marker
                          key={businessData.id}
                          icon={{
                            url: invertesIcon, 
                          }}
                          position={{ lat:businessData?.latitude, lng: businessData?.longitude }}  
                          onClick={() => handleActiveMarker(businessData.id)}
                        >
                          {activeMarker === businessData.id ? (  
                            <InfoWindow onCloseClick={() => setActiveMarker(null)} options={{ maxWidth: 320 }}>
                              <div>
                                <h4>{businessData?.name} </h4> 
                              </div>
                            </InfoWindow> 
                          ) : null}
                        </Marker>
                      }
                    </>
                  </Map>
                </div>
              </div>
            </Col>
          </Row> 

          {
            businessData?.ext_community?.type === 'AmiIoT' &&
            <Row gutter={[16, 8]}>
              <Col span={24}>
                <Row>
                  <Card className={styles.tables}>
                    <ResponsiveContainer width="100%">
                      <div className={styles.tables}>
                        <Row className={styles.headerTables} gutter={[8, 8]}>

                          <Col xs={{span: 24,order: 1, }} sm={{span: 24,order: 1, }} md={{span: 14,order: 2, }} lg={{span: 14,order: 2, }} xl={{span: 14,order: 2, }}
                          >
                            <Input
                              placeholder={t('common.find')}
                              className={styles.search} 
                              prefix={<SearchOutlined />}
                              onChange={(e) => setValueFilterDevices(e.target.value)} 
                              allowClear
                            />
                          </Col> 

                          <Col
                            className="select-filter"
                            xs={{ span: 24, order: 2}} sm={{ span: 24, order: 2}} md={{ span: 6, order: 3}} lg={{ span: 6, order: 3}} xl={{ span: 6, order: 3}}
                          >
                            <Select
                              defaultValue="todos"
                              className={styles.select_device} 
                              onChange={setStatusDevices}
                              options={[
                                {
                                  value: 'todos',
                                  label: t('common.show_all'),
                                },
                                {
                                  value: 'conectados',
                                  label: t('common.connected'),
                                },
                                {
                                  value: 'desconectados',
                                  label: t('common.disconnected'),
                                },
                              ]}
                            />
                          </Col>
                          
                          {
                            isCreate &&
                            <Col xs={{span: 24,order: 4, }} sm={{span: 24,order: 4, }} md={{span: 4,order: 4, }} lg={{span: 4,order: 4, }} xl={{span: 4,   order: 4, }}
                            >
                              <Button type="primary" className={styles.btn_create} onClick={createDevice} >
                                {t('views.create_devices.new_device')}
                              </Button>
                            </Col>
                          }
                          

                        </Row>
                      </div>
                    </ResponsiveContainer>
                  </Card>
                </Row>

                <Card className={styles.tables}>
                  <ResponsiveContainer width="100%">
                    <div className={styles.tables}>
                      <Table
                        className={styles.table} 
                        columns={columnsDevices}
                        dataSource={arrayFilterDevices} 
                        rowKey={(record) => record.id}
                      />
                    </div>
                  </ResponsiveContainer>
                </Card>
              </Col>
            </Row>
          }

          <Row gutter={[16, 8]}>
              <Col span={24}>
                <Row>
                  <Card className={styles.tables}>
                    <ResponsiveContainer width="100%">
                      <div className={styles.tables}>
                        <Row className={styles.headerTables} gutter={[8, 8]}>

                          <Col xs={{span: 24,order: 1, }} sm={{span: 24,order: 1, }} md={{span: 20,order: 2, }} lg={{span: 20,order: 2, }} xl={{span: 20,order: 2, }}
                          >
                             <Input
                                size="large"
                                placeholder={t('common.find_by_client')}
                                prefix={<SearchOutlined />}
                                style={{}}
                                onChange={(e) => setValueFilterClients(e.target.value)}
                              />
                          </Col>  
                          
                          {
                            isCreate &&
                            <Col xs={{span: 24,order: 4, }} sm={{span: 24,order: 4, }} md={{span: 4,order: 4, }} lg={{span: 4,order: 4, }} xl={{span: 4,   order: 4, }}
                            >
                               <Button type="primary" style={{ float: 'right', padding: '.5rem 1rem 1.8rem', width: '100%' }} onClick={createClient}>
                                  {t('forms.clients.buttons.create')}
                                </Button>
                            </Col>
                          }

                        </Row>
                      </div>
                    </ResponsiveContainer>
                  </Card>
                </Row>
                
                <Card className={styles.tables}>
                  <Table 
                    loading={loading}
                    className={styles.table}
                    columns={columnsClients}
                    dataSource={arrayFilterClients}
                    rowKey={(record) => record.id} 
                  />
                </Card>
 
              </Col>
            </Row>

        </>)}
    </div>
  );

}

export default DashboardAdmin;
